import CrudRepository from './CrudRepository'
export default class ActiveBundlesRepository extends CrudRepository {
  constructor () {
    super('core/api/bundles/active/overview')
  }
}
